import { URLField } from "@overmap-ai/forms"
import type { ReactNode } from "react"

import {
	NullableStringEqualsFilterModifier,
	NullableStringNotEqualsFilterModifier,
	StringExcludesFilterModifier,
	StringIncludesFilterModifier,
} from "../../modifiers"
import { BaseFilterDef, createFilterModifierConfig, type FilterDefRenderProps } from "../BaseFilterDef"
import { URLFieldFilterCell } from "./URLFieldFilterCell"

type URLFieldValue = string | null
type URLFilterValue = string | null

export class URLFieldFilterDef extends BaseFilterDef<URLFieldValue, URLFilterValue> {
	readonly id: string
	readonly defaultFilterValue: URLFilterValue | undefined = undefined
	readonly defaultFilterModifier: keyof typeof this.modifiers = "equals"

	readonly field: URLField

	constructor(field: URLField) {
		super()
		this.field = field
		this.id = field.id
	}

	readonly modifiers = {
		equals: createFilterModifierConfig({
			modifier: NullableStringEqualsFilterModifier,
			isValueValid: (_value: URLFieldValue): _value is string => true,
			isFilterValueValid: (_filterValue: URLFilterValue): _filterValue is string | null => true,
		}),
		notEquals: createFilterModifierConfig({
			modifier: NullableStringNotEqualsFilterModifier,
			isValueValid: (value: URLFieldValue): value is string => value !== null,
			isFilterValueValid: (_filterValue: URLFilterValue): _filterValue is string | null => true,
		}),
		includes: createFilterModifierConfig({
			modifier: StringIncludesFilterModifier,
			isValueValid: (value: URLFieldValue): value is string => value !== null,
			isFilterValueValid: (filterValue: URLFilterValue): filterValue is string => filterValue !== null,
		}),
		excludes: createFilterModifierConfig({
			modifier: StringExcludesFilterModifier,
			isValueValid: (value: URLFieldValue): value is string => value !== null,
			isFilterValueValid: (filterValue: URLFilterValue): filterValue is string => filterValue !== null,
		}),
	}

	render(props: FilterDefRenderProps<URLFieldFilterDef>): ReactNode {
		return <URLFieldFilterCell key={props.filter.id} field={this.field} {...props} />
	}
}
